import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoBm: CultureInfo = {
  name: 'bm',
  displayName: 'bamanakan',
  iso3LanguageCode: 'bam',
  iso2LanguageCode: 'bm',
  ietfLanguageTag: 'bm',
  parent: null
};
